export default __webpack_public_path__ + "static/media/Arrow_04-down.10dd4f4a.svg";